import React,{useEffect,useRef,useState} from 'react';
import {api} from '@/lib/api';

export function documentSummary(data){
 if(!Array.isArray(data?.documents))return 'Unavailable';
 const count=data.documents.length;
 return count?`${count} on file`:'None on file';
}
export function reviewSummary(data){
 if(!Array.isArray(data?.reviews))return 'Unavailable';
 const dates=data.reviews.filter(review=>review.status==='scheduled'&&/^\d{4}-\d{2}-\d{2}$/.test(review.due_date||'')).map(review=>review.due_date).filter(value=>{const date=new Date(`${value}T12:00:00Z`);return !Number.isNaN(date.getTime())&&date.toISOString().slice(0,10)===value;}).sort();
 return dates.length?new Intl.DateTimeFormat(undefined,{month:'short',day:'numeric',year:'numeric'}).format(new Date(`${dates[0]}T12:00:00`)):'Not scheduled';
}
export default function EmployeeFolderSummary({employeeId,canOpen}){
 const ref=useRef(null),[visible,setVisible]=useState(false),[summary,setSummary]=useState(null);
 useEffect(()=>{
  if(!canOpen)return undefined;
  if(typeof IntersectionObserver==='undefined'){setVisible(true);return undefined;}
  const observer=new IntersectionObserver(entries=>{if(entries.some(entry=>entry.isIntersecting)){setVisible(true);observer.disconnect();}},{root:ref.current?.closest('.folder-review__rail'),rootMargin:'0px 100px'});
  if(ref.current)observer.observe(ref.current);
  return()=>observer.disconnect();
 },[canOpen]);
 useEffect(()=>{
  if(!visible||!canOpen)return undefined;
  let active=true;const controller=new AbortController();setSummary(null);
  const id=encodeURIComponent(employeeId);
  Promise.allSettled([api.get(`/employee-documents/${id}`,{signal:controller.signal}),api.get(`/reviews/employee/${id}`,{signal:controller.signal})]).then(([documents,reviews])=>{
   if(active)setSummary({id:employeeId,documents:documents.status==='fulfilled'?documentSummary(documents.value.data):'Unavailable',reviews:reviews.status==='fulfilled'?reviewSummary(reviews.value.data):'Unavailable'});
  });
  return()=>{active=false;controller.abort();};
 },[employeeId,canOpen,visible]);
 const current=summary?.id===employeeId?summary:null;
 return <span ref={ref} className="folder-review__summary"><span><span className="folder-review__summary-label">Documents</span><span className="folder-review__summary-value">{canOpen?(current?.documents||'Loading…'):'Restricted'}</span></span><span><span className="folder-review__summary-label">Next review</span><span className="folder-review__summary-value">{canOpen?(current?.reviews||'Loading…'):'Restricted'}</span></span></span>;
}
